module.exports = __webpack_public_path__ + "img/employer_benefit_scorecentric.0b51ac88.jpg";